var map = {
	"./lev-slantshack.jpg": 9967,
	"./logo-newsletter.png": 5560,
	"./recipal-avery-1.jpg": 889,
	"./recipal-avery-2.jpg": 2729,
	"./recithink.png": 3135,
	"./satisfaction-guarantee.png": 7629,
	"./stripe-climate.svg": 6727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9567;